import React from 'react';
import Footer from '../components/HomePageNew/Footer';
//import MenuNew from '../components/MenuNew';
import Aide from '../components/HomePageNew/Aide';
//import NavbarDrop from '../components/HomePageNew/NavbarDrop';
import ConfirmProposal from '../components/ConfirmProposal';


const ConfirmProposalPage = () => {

  return (
    <div>
      {/*<MenuNew />
      <NavbarDrop/> */}
      <ConfirmProposal />
      <Footer/>
      <Aide />
    </div>
  );
};

export default ConfirmProposalPage;



/** WEBPACK FOOTER **
 ** ./src/containers/ConfirmProposalPage.js
 **/